import { state } from '../state';
import { APP_DATA } from '../appData';
import { RINGS, CX, CY, INSTALLER_SCANNER_DIM_STRENGTH_DEFAULT } from '../config';
import { clamp } from '../utils/math';
import {
  ensureRingGuide,
  createItemFromData,
  getItemBaseScale,
} from '../layout/ringLayout';

export function createItems(): void {
  state.items = [];
  for (let i = 0; i < RINGS.length; i++) ensureRingGuide(i);

  for (let i = 0; i < APP_DATA.length; i++) {
    const entry = APP_DATA[i];
    if (!entry) continue;
    const item = createItemFromData(entry, i);
    state.items.push(item);
  }

  state.installerSlotIndex = APP_DATA.findIndex(a => (a.kind || '') === 'installer');
  state.installerItem = state.installerSlotIndex >= 0
    ? state.items.find(item => item.slotIndex === state.installerSlotIndex) ?? null
    : null;
}

export function setAppScaleBoostByName(name: string, boost = 0): boolean {
  if (!name) return false;
  const key = String(name).trim().toLowerCase();
  const item = state.items.find(it => String(it.name || '').trim().toLowerCase() === key);
  if (!item) return false;
  item.organismScaleBoost = clamp(Number(boost) || 0, -0.5, 1.75);
  item.settledScale = getItemBaseScale(item);
  return true;
}

export function clearAppScaleBoosts(): void {
  for (const item of state.items) {
    item.organismScaleBoost = 0;
    item.settledScale = getItemBaseScale(item);
  }
}

export function setInstallerScannerDimOpacity(strength = INSTALLER_SCANNER_DIM_STRENGTH_DEFAULT): number {
  const parsed = Number(strength);
  const fallback = INSTALLER_SCANNER_DIM_STRENGTH_DEFAULT;
  state.installerScannerDimStrength = clamp(Number.isFinite(parsed) ? parsed : fallback, 0, 0.95);
  return state.installerScannerDimStrength;
}

export function setInstallerScannerDimStrength(strength = INSTALLER_SCANNER_DIM_STRENGTH_DEFAULT): number {
  return setInstallerScannerDimOpacity(strength);
}

export function setAppAnchorByName(name: string, x: number, y: number): boolean {
  if (!name) return false;
  const key = String(name).trim().toLowerCase();
  const item = state.items.find(it => String(it.name || '').trim().toLowerCase() === key);
  if (!item) return false;
  item.baseX = clamp(Number(x) || CX, 0, 800);
  item.baseY = clamp(Number(y) || CY, 0, 800);
  item.targetX = item.baseX;
  item.targetY = item.baseY;
  state.lockHourItems = null;
  return true;
}
